// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant'
import VueLazyload from 'vue-lazyload'
import 'vant/lib/index.css'
import Http from "./service/network"

import VueClipboard from 'vue-clipboard2'
Vue.config.productionTip = false
// 把http挂载到vue实例上
Vue.prototype.$Http = Http
Vue.prototype.Aliplayer = ''
Vue.use(Vant)
Vue.use(ElementUI);
Vue.use(VueClipboard)
Vue.use(VueLazyload, {
  lazyComponent: true
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js